import React from 'react';

const STATUS_LABELS = { present: 'Närvarande', absent: 'Frånvarande', null: 'Ej registrerad' };
const STATUS_COLORS = {
  present: 'bg-green-100 text-green-700',
  absent:  'bg-red-100 text-red-700',
  null:    'bg-gray-100 text-gray-500',
};

const StatusBadge = ({ status }) => (
  <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${STATUS_COLORS[status ?? 'null']}`}>
    {STATUS_LABELS[status ?? 'null']}
  </span>
);

const AttendanceDayView = ({
  participants,
  getEffectiveStatus,
  getEffectiveNote,
  mode,
  selected,
  onToggleSelect,
  onSelectAll,
  onStatusChange,
  onNoteChange,
  date,             // 'YYYY-MM-DD'
}) => {
  const allSelected = participants.length > 0 && participants.every(p => selected.has(p.id));

  return (
    <div data-testid="day-view">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b">
            {mode === 'register' && (
              <th className="w-10 py-2 px-3">
                <input
                  type="checkbox"
                  data-testid="select-all"
                  checked={allSelected}
                  onChange={() => onSelectAll(!allSelected)}
                  className="rounded"
                  aria-label="Markera alla"
                />
              </th>
            )}
            <th className="text-left py-2 px-3 font-bold">Namn</th>
            <th className="text-left py-2 px-3 font-bold">Status</th>
            {mode === 'register' && (
              <th className="text-left py-2 px-3 font-bold">Notering</th>
            )}
          </tr>
        </thead>
        <tbody>
          {participants.map(p => {
            const status = getEffectiveStatus(p.id, date);
            const note   = getEffectiveNote(p.id, date);
            return (
              <tr
                key={p.id}
                data-testid={`day-row-${p.id}`}
                className={`border-b transition-colors ${selected.has(p.id) ? 'bg-yellow-50' : 'hover:bg-muted/40'}`}
              >
                {mode === 'register' && (
                  <td className="py-2 px-3">
                    <input
                      type="checkbox"
                      data-testid={`select-${p.id}`}
                      checked={selected.has(p.id)}
                      onChange={() => onToggleSelect(p.id)}
                      className="rounded"
                      aria-label={`Välj ${p.name}`}
                    />
                  </td>
                )}
                <td className="py-2 px-3 font-medium">{p.name}</td>
                <td className="py-2 px-3">
                  {mode === 'overview' ? (
                    <StatusBadge status={status} />
                  ) : (
                    <select
                      data-testid={`status-${p.id}`}
                      value={status ?? ''}
                      onChange={e => onStatusChange(p.id, date, e.target.value || null)}
                      className="h-8 px-2 border border-input rounded-md bg-background text-xs focus:outline-none focus:ring-2 focus:ring-ring"
                    >
                      <option value="">Ej registrerad</option>
                      <option value="present">Närvarande</option>
                      <option value="absent">Frånvarande</option>
                    </select>
                  )}
                </td>
                {mode === 'register' && (
                  <td className="py-2 px-3">
                    <input
                      type="text"
                      data-testid={`note-${p.id}`}
                      value={note}
                      onChange={e => onNoteChange(p.id, date, e.target.value)}
                      placeholder="Valfri notering"
                      className="h-8 w-full px-2 border border-input rounded-md bg-background text-xs focus:outline-none focus:ring-2 focus:ring-ring"
                    />
                  </td>
                )}
              </tr>
            );
          })}
          {participants.length === 0 && (
            <tr>
              <td colSpan={mode === 'register' ? 4 : 2} className="py-8 text-center text-muted-foreground text-sm">
                Inga deltagare hittades.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceDayView;
